import React from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
// import styles from './flex.scss'

interface Props {
    width?: string|number;
    height?: string|number;
    grow?: number;
    shrink?: number;
    style?: ViewStyle|Array<ViewStyle>;
}

const Flex: React.FC<Props> = (props) => {

    const {
        width,
        height,
        grow = 1,
        shrink = 0,
        style
    } = props;

    const FlexStyle: ViewStyle = {
        width: width,
        height: height,
        flexShrink: shrink,
        flexGrow: grow
    };

    return (
        <View {...props} style={[styles.flex, style, FlexStyle]}>
            {props.children}
        </View>
    );

};

const styles = StyleSheet.create({
    flex: {
        flex: 1,
        flexShrink: 0,
        flexGrow: 1
    }
});

export {
    Flex
}